<script setup>
import { computed } from 'vue';

const props = defineProps({
  // 是否显示
  visible: {
    type: Boolean,
    default: false,
  },
  // 彩带数量
  count: {
    type: Number,
    default: 50,
  },
  // 动画时长（秒）
  duration: {
    type: Number,
    default: 3,
  },
  // 颜色数组
  colors: {
    type: Array,
    default: () => [
      '#ef4444',
      '#f97316',
      '#eab308',
      '#22c55e',
      '#06b6d4',
      '#3b82f6',
      '#8b5cf6',
      '#ec4899',
    ],
  },
});

// 预生成彩带数据（避免每次渲染重新计算）
const confettiData = computed(() => {
  return Array.from({ length: props.count }, (_, i) => {
    // 形状：0=方块, 1=条形, 2=圆形
    const shape = Math.floor(Math.random() * 3);

    return {
      id: i,
      delay: i * (props.duration / props.count) * 0.5,
      x: Math.random() * 100,
      color: props.colors[i % props.colors.length],
      size: 12 + Math.random() * 16, // 更大尺寸：12-28px
      shape,
      duration: props.duration * (0.8 + Math.random() * 0.4),
    };
  });
});
</script>

<template>
  <Teleport to="body">
    <div v-if="visible" class="confetti-container">
      <div
        v-for="item in confettiData"
        :key="item.id"
        class="confetti"
        :class="[
          { 'confetti--ribbon': item.shape === 1 },
          { 'confetti--circle': item.shape === 2 },
        ]"
        :style="{
          '--delay': `${item.delay}s`,
          '--x': `${item.x}%`,
          '--color': item.color,
          '--size': `${item.size}px`,
          '--duration': `${item.duration}s`,
        }"
      />
    </div>
  </Teleport>
</template>

<style scoped>
/* 彩带庆祝效果 */
.confetti-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 9999;
}

.confetti {
  position: absolute;
  top: -20px;
  left: var(--x);
  width: var(--size);
  height: var(--size);
  background: var(--color);
  border-radius: 3px;
  animation: confetti-fall var(--duration) ease-out forwards;
  animation-delay: var(--delay);
  opacity: 0;
}

/* 条形彩带 */
.confetti--ribbon {
  width: calc(var(--size) * 2.5);
  height: calc(var(--size) * 0.6);
  border-radius: 4px;
}

/* 圆形 */
.confetti--circle {
  border-radius: 50%;
}

@keyframes confetti-fall {
  0% {
    transform: translateY(0) rotate(0deg) scale(0);
    opacity: 0;
  }
  10% {
    opacity: 1;
    transform: translateY(20px) rotate(180deg) scale(1);
  }
  100% {
    transform: translateY(calc(100vh + 50px)) rotate(1080deg) scale(0.5);
    opacity: 0;
  }
}
</style>
